import { ButtonPropsSizeOverrides, ButtonPropsVariantOverrides, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { OverridableStringUnion } from '@mui/types';
import getBrowser from 'common/src/helpers/utilities/browser/getBrowser';
import React, { useState } from 'react';
import { DeviceType, useBreakpoint } from '../../../../hooks/useBreakpoint';
import { StyledDocumentButton } from '../../CfDocumentViewer.styles';

export interface CfDocumentViewerPrintButtonProps {
  fileName: string;
  fileSrc: string;
  variant?: OverridableStringUnion<'text' | 'outlined' | 'contained', ButtonPropsVariantOverrides>;
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>;
  text?: string;
  sx?: SxProps<Theme>;
}

const CfDocumentViewerPrintButton: React.FC<CfDocumentViewerPrintButtonProps> = (
  props: CfDocumentViewerPrintButtonProps
) => {
  const { deviceType } = useBreakpoint();
  const [disabledButton, setDisabledButton] = useState(false);
  const _iOSDevice = /iPhone|iPod|iPad/.test(navigator.platform);
  const isMobile = deviceType === DeviceType.Mobile || deviceType === DeviceType.Tablet;
  const browser = getBrowser();

  const handleClick = (): void => {
    setDisabledButton(true);

    const iframe = document.querySelector('iframe[data-document-viewer]') as HTMLIFrameElement | null;

    if (iframe?.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }

    setDisabledButton(false);
  };

  return (
    <StyledDocumentButton
      variant={props.variant ?? 'contained'}
      color='primary'
      onClick={handleClick}
      size={props.size}
      disabled={disabledButton}
      sx={props.sx}
    >
      {props.text ?? 'Print'}
    </StyledDocumentButton>
  );
};

export default CfDocumentViewerPrintButton;
